<template>
    <v-dialog v-model="dialog" width="1200px">
        <v-card>
            <v-card-title class="justify-center">Bulk delete of photo's {{ huis.huis_code }}</v-card-title>
            <v-divider/>
            <div class="scrollable">
                <v-row no-gutters>
                    <v-col v-for="p in huis.hsft_aant" :key="p" id="content" class="pa-2" cols=2>
                        <figure>
                            <figcaption>&nbsp; {{ huis.hsft[parseInt(p) - 1].hsft_nr }}</figcaption>
                            <img :src="huis.hsft[parseInt(p) - 1].hsft_foto" class="px-1" :title="huis.hsft[parseInt(p) - 1].hsft_tag">
                            <v-checkbox v-model="selected" :value="huis.hsft[parseInt(p) - 1].hsft_encrid" label="Delete" class="my-0"></v-checkbox> 
                        </figure>                         
                    </v-col>
                </v-row>
            </div>
            <v-divider/>
            <v-row dense class="pa-2 ma-0" cols="12">
                <span class="px-4" v-if="selected.length>0">{{ selected.length }} Photo's selected</span>
                <span class="px-4" v-else>No photo's selected</span>
                <v-spacer></v-spacer>
                <span :style="{ color: 'red' }" v-if="confirmCounter > 0">Press "confirm delete" to confirm delete of the Photo's ({{ confirmCounter }})</span>
                <span :style="{ color: 'red' }" v-else>{{ message }}</span>
            </v-row>
            <v-divider/>
            <v-card-actions>
                <v-btn color="primary" small @click="selectAll()">Select All</v-btn>
                <v-btn color="primary" small @click="clearAll()">Clear selection</v-btn>
                <v-spacer/>
                <v-btn class="warning mr-3" small :disabled="selected.length===0" @click="rmHsftConfirm()" v-if="confirmCounter <= 0">Delete</v-btn>
                <v-btn class="warning mr-3" small @click="bulkDelete()" v-else>Confirm Delete</v-btn>
                <v-btn color="primary" small @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    // import { bus } from "../../../main";

    export default {
            components: {
        },
        data() { 
            return {
                dialog: false,
                confirmTimer: null,
                confirmCounter: 0,
                fttg_nrKeuzes: [],
                hsft: {},
                hsft_array: [],
                huis: {},
                selected: [],
                message: "",
                delCounter: 0,
            }
        },
        computed: {
            reactivePhotoArray: function () {
                return this.hsft_array.filter(() => {
                    return true;
                });
            }
        },
        methods: {
            openDialog(huis) {
                this.huis = huis;
                this.message = "";
                this.selected = [];
                this.dialog = true;
            },
            selectAll() {
                this.selected = [];
                for (let i=0; i < this.huis.hsft.length; i++) {
                    this.selected.push(this.huis.hsft[i].hsft_encrid);
                }            
            },
            clearAll() {
                this.selected = [];          
            },
            closeDialog() {
                // for (let i=0; i < this.selected.length; i++) {
                //     alert(this.selected[i]);
                // }            
                this.dialog = false;
            },
            rmHsftConfirmCountdown() {
                this.confirmCounter -= 1;
                if (this.confirmCounter <= 0) {
                    clearInterval(this.confirmTimer);
                }
            },
            rmHsftConfirm() {
                this.confirmCounter = 5;
                this.confirmTimer = setInterval(this.rmHsftConfirmCountdown, 1000);
            },
            bulkDelete() {
                this.confirmCounter = 0;
                clearInterval(this.confirmTimer);
                this.message = "Please wait: Deleting photo's";
                this.$axios.post("ares/json/ares/huis/hsft/rmHsft2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHsft2"
                    },
                    rmHsft2: {
                        hsft_encrids: this.selected
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmHsft2.text,
                            color: res.data.rmHsft2.color
                        });
                        // if (res.data.rmHsft2.color == "success") { 
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.$emit("updateData");
                        this.dialog = false;
                    }
                    this.message = "";
                })
            },
        }
    }
</script>

<style scoped>
    .flex{
        display: flex;
        flex-direction: row;
    }
    .scrollable {
        max-height: 600px;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>
